import { render, staticRenderFns } from "./RadioInput.vue?vue&type=template&id=4bbf1edc&scoped=true&"
import script from "./RadioInput.vue?vue&type=script&lang=js&"
export * from "./RadioInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbf1edc",
  null
  
)

export default component.exports